import React, { useEffect, useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { useQuery, useMutation } from "@tanstack/react-query";
import CashierApi from "../../utility/CashierApi";

function GeneratePinModal({ oldPin, open, handleClose }) {
  const { fetchPinData, createData } = CashierApi();

  const [shouldFetch, setShouldFetch] = useState(false);
  const [newPin, setNewPin] = useState(null);
  const [nextPhase, setNextPhase] = useState(false);

  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["generatePin", shouldFetch],
    queryFn: () => fetchPinData("users/generate-passcode"),
    enabled: shouldFetch,
    staleTime: 0,
    cacheTime: 0,
  });

  useEffect(() => {
    if (isSuccess && data) {
      setNewPin(data.data);
      setShouldFetch(false);
    }
  }, [isSuccess, data]);

  useEffect(() => {
    if (newPin) {
      setNextPhase(true);
    }
  }, [newPin]);

  const pinUpdateMutation = useMutation({
    mutationFn: (pin) => createData(`users/profile_update`, { login_pin: pin }),
    onSuccess: () => {
      handleClose(true);
      setNextPhase(false);
      setNewPin(null);
    },
    onError: (error) => {
      console.error("Mutation failed:", error);
    },
  });

  const handleGeneratePin = () => {
    setShouldFetch(true);
  };

  const handleUpdate = () => {
    if (newPin) {
      pinUpdateMutation.mutate(newPin);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 shadow-lg">
        <div className="flex justify-end">
          <CancelIcon
            onClick={() => handleClose(true)}
            className="cursor-pointer text-black"
          />
        </div>
        <div className="flex flex-col text-black p-4">
          <div className="flex justify-center gap-4">
            {oldPin && (
              <div className="flex flex-col">
                <h4>Old Pin</h4>
                <input
                  type="text"
                  value={oldPin}
                  className="p-1 w-16 text-center bg-gray-300 rounded-md"
                  disabled
                />
              </div>
            )}
            {newPin && (
              <div className="flex flex-col">
                <h4 className="text-center w-full">New Pin</h4>
                <input
                  type="text"
                  value={newPin}
                  className="p-1 w-16 text-center bg-gray-300 rounded-md"
                  disabled
                />
              </div>
            )}
          </div>
          {newPin ? (
            <button
              type="button"
              onClick={handleUpdate}
              className="p-2 my-4 rounded-lg text-white w-full bg-blue-500 hover:bg-blue-600"
            >
              Save Password
            </button>
          ) : (
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => handleClose(true)}
                className="p-2 my-4 rounded-lg text-white w-full bg-blue-500 hover:bg-blue-600"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleGeneratePin}
                className="p-2 my-4 rounded-lg text-white text-nowrap w-full bg-blue-500 hover:bg-blue-600"
              >
                {isLoading ? "Generating..." : "Generate Pin"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default GeneratePinModal;
